
<f-dialog
    :title       = "$t('img.upload.title')"
    v-model      = "show"
    :width       = "520"
    :store-label = "finished ? $t('common.close') : $t('img.upload.store')"
    :show-save   = "finished || (pending.length > 0 && !running)"
    :show-cancel = "!finished"
    @cancel      = "onClose"
    @store       = "finished ? onClose() : onUpload()"
>
    <template v-slot:content>
        <div class="mb-2">
            {{ $t('img.upload.folder') }}: <b>{{ folderLabel }}</b>
        </div>

        <v-file-input
            v-model     = "selected"
            :label      = "$t('img.upload.select')"
            multiple
            chips
            small-chips
            :accept     = "accept"
            :disabled   = "running"
            :show-size  = "true"
            hide-details
            @change     = "onSelect"
        />

        <v-row dense v-for="item in items" :key="item.key" class="upload-item">
            <v-col class="upload-name">{{ item.file.name }}</v-col>
            <v-col class="upload-state" :class="{'error--text': item.state === 'FAILED'}">
                {{ $t('img.upload.state.' + item.state) }}
                <span v-if="item.reason"> ({{ item.reason }})</span>
            </v-col>
        </v-row>
        <div class="mb-6"></div>
    </template>
</f-dialog>
